package com.taocent.simple.compose.component.blockrichtext.internal.registry

enum class BlockKind {

    TEXT,

    TABLE
}
